export default "__VITE_ASSET__BghchwUm__"